import { render, staticRenderFns } from "./Anonymous-instruction.vue?vue&type=template&id=c8c05776"
import script from "./Anonymous-instruction.vue?vue&type=script&lang=js"
export * from "./Anonymous-instruction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports